import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const ViewOrder = () => {
    const navigate = useNavigate();

    const order = {
        orderId: "#Order_1001",
        storeid:"#Store_101",
        user: {
            name: "John Doe",
            email: "john.doe@example.com",
            phone: "987-654-3210",
            profilePhoto: "/static/images/user_placeholder.png",
        },
        yoghurt: {
            quantity: "300 ml",
            flavor: "Mango",
            toppings: "Mango Chunks, Pistachios, Honey Drizzle",
            totalUnits: 2,
            paymentDetails: "$12.99",
            orderDate: "01 Oct 2025, 10:30 AM",
        },
        delivery: {
            pickupStore: "Saginaw Supercenter",
            addressLine1: "123 Main Street",
            addressLine2: "Apartment 4B",
            cityStateCountry: "Saginaw, TX, USA",
            zipcode: "76179",
        },
        bookingDate: "01 Oct 2025, 10:00 AM",
        deliveryDate: "03 Oct 2025, 2:00 PM",
        payment: {
            orderSummary: "$12.99",
            grandTotal: "$12.99",
            mode: "Credit Card",
            status: "Successful",
        },
    };

    return (
        <>
            <div className="main_title">
                <h1>View Order Details</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
                    <button onClick={() => navigate(-1)}>Manage Orders</button> - View Order
                </p>
            </div>

            <div className="cards view_page">
                <div className="gap_p">

                    {/* Order ID */}
                    <div className="w_33">
                        <h6>Order ID</h6>
                        <p>{order.orderId}</p>
                    </div>
                    <div className="w_33">
                        <h6>Store ID</h6>
                        <p>{order.storeid}</p>
                    </div>

                    {/* User Details */}
                    <div className="w_33 vew_img">
                        <h6>User Details</h6>
                        <Box className="user_block">

                            <figure>
                                <img
                                    src={order.user.profilePhoto}
                                    alt={order.user.name}
                                    className="product_image"
                                />
                            </figure>
                            <p>
                                <b>{order.user.name}</b>
                                {order.user.email} <br />
                                {order.user.phone}
                            </p>
                        </Box>
                    </div>
                    <div className="w_33 vew_img">
                        <h6>Driver Details</h6>
                        <Box className="user_block">

                            <figure>
                                <img
                                    src={order.user.profilePhoto}
                                    alt={order.user.name}
                                    className="product_image"
                                />
                            </figure>
                            <p>
                                <b>{order.user.name}</b>
                                {order.user.email} <br />
                                {order.user.phone}
                            </p>
                        </Box>
                    </div>
               

                    {/* Yoghurt Details */}
                    <div className="w_33">
                        <h6>Quantity</h6>
                        <p>{order.yoghurt.quantity}</p>
                    </div>
                    <div className="w_33">
                        <h6>Flavor</h6>
                        <p>{order.yoghurt.flavor}</p>
                    </div>
                    <div className="w_33">
                        <h6>Toppings</h6>
                        <p>{order.yoghurt.toppings}</p>
                    </div>
                    <div className="w_33">
                        <h6>Total Units</h6>
                        <p>{order.yoghurt.totalUnits}</p>
                    </div>
                    <div className="w_33">
                        <h6>Payment Amount</h6>
                        <p>{order.yoghurt.paymentDetails}</p>
                    </div>
                    <div className="w_33">
                        <h6>Order Date & Time</h6>
                        <p>{order.yoghurt.orderDate}</p>
                    </div>

                    {/* Delivery Details */}
                    <div className="w_33">
                        <h6>Pickup Store</h6>
                        <p>{order.delivery.pickupStore}</p>
                    </div>
                    <div className="w_33">
                        <h6>Address Line 1</h6>
                        <p>{order.delivery.addressLine1}</p>
                    </div>
                    <div className="w_33">
                        <h6>Address Line 2</h6>
                        <p>{order.delivery.addressLine2}</p>
                    </div>
                    <div className="w_33">
                        <h6>City/State/Country</h6>
                        <p>{order.delivery.cityStateCountry}</p>
                    </div>
                    <div className="w_33">
                        <h6>Pincode/Zipcode</h6>
                        <p>{order.delivery.zipcode}</p>
                    </div>

                    {/* Booking & Delivery */}
                    <div className="w_33">
                        <h6>Booking Date & Time</h6>
                        <p>{order.bookingDate}</p>
                    </div>
                    <div className="w_33">
                        <h6>Delivery Date & Time</h6>
                        <p>{order.deliveryDate}</p>
                    </div>

                    {/* Payment Details */}
                    <div className="w_33">
                        <h6>Order Summary</h6>
                        <p>{order.payment.orderSummary}</p>
                    </div>
                    <div className="w_33">
                        <h6>Grand Total</h6>
                        <p>{order.payment.grandTotal}</p>
                    </div>
                    <div className="w_33">
                        <h6>Payment Mode</h6>
                        <p>{order.payment.mode}</p>
                    </div>
                    <div className="w_33">
                        <h6>Payment Status</h6>
                        <p>{order.payment.status}</p>
                    </div>

                </div>
            </div>
        </>
    );
};

export default ViewOrder;
